import React from "react";
import styles from "./Exceptions.module.css";

const rows = [
  { priority: "High", exception: "Unmatched Credits", amount: "₦1.25M", age: "4 days", owner: "Ade" },
  { priority: "High", exception: "Duplicate Payment", amount: "₦840K", age: "6 days", owner: "Tolu" },
  { priority: "Medium", exception: "Bank Charge", amount: "₦85K", age: "2 days", owner: "Bola" },
  { priority: "Medium", exception: "Timing Difference", amount: "₦320K", age: "3 days", owner: "Chidi" },
  { priority: "Low", exception: "Rounding Difference", amount: "₦12K", age: "1 day", owner: "Emeka" },
];

const PriorityDot = ({ level }) => {
  const cls = level === "High" ? styles.high : level === "Medium" ? styles.medium : styles.low;
  return <span className={`${styles.priorityDot} ${cls}`} aria-hidden />;
};

const Exceptions = () => {
  return (
    <div className={styles.cardWrap}>
      <div style={{display:'flex',justifyContent:'space-between',alignItems:'center'}}>
        <h3 className={styles.title}>Exceptions Requiring Attention</h3>
        {/* <a className={styles.viewAll} href="#">View all</a> */}
      </div>

      <div className={styles.contentWrap}>
        <table className={styles.table}>
        <thead className={styles.thead}>
          <tr>
            <th>Priority</th>
            <th>Exceptions</th>
            <th>Amount</th>
            <th>Age</th>
            {/* <th>Owner</th> */}
          </tr>
        </thead>

        <tbody className={styles.tbody}>
          {rows.map((r, i) => (
            <tr key={i}>
              <td><PriorityDot level={r.priority} /> <span className={styles.nameSmall}>{r.priority}</span></td>
              <td className={styles.nameSmall}>{r.exception}</td>
              <td className={styles.amount}>{r.amount}</td>
              <td className={styles.age}>{r.age}</td>
              {/* <td>
                <div className={styles.owner}>
                  <div className={styles.avatar}>{r.owner.slice(0,2).toUpperCase()}</div>
                  <div className={styles.nameSmall}>{r.owner}</div>
                </div>
              </td> */}
            </tr>
          ))}
        </tbody>
        </table>
      </div>
    </div>
  );
};

export default Exceptions;
